// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-avatar[data-v-16c691d4]{display:flex;position:relative}.review-avatar>img[data-v-16c691d4]{background-color:#f1f3f5;border-radius:50%;height:100%;-o-object-fit:cover;object-fit:cover;overflow:hidden;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
